module.exports = __webpack_public_path__ + "static/img/face1.a3689b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face1.png
// module id = SIRn
// module chunks = 1